// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customer-detail-dialog-tabs{height:100%;padding-bottom:20px}.customer-detail-dialog-tabs .message-input{margin-top:0;height:auto}.messages{display:grid;grid-template-rows:1fr 52px;height:inherit}", ""]);
// Exports
module.exports = exports;
